import { FC, useState, useRef, useEffect, ChangeEvent } from "react";
import { ArrowDownIcon } from "src/components/icons/arrow-down";
import { SearchIcon } from "src/components/icons/search-icon";
import Dropdown from "src/components/ui/filter-dropdown-list";
import { PAYMENT_OPTIONS } from "src/lib/constants";
import { CurrencyDataType } from "src/lib/constants/table-type";
import { convertPaymentSystem } from "../../lib/utils";


interface ICurrencyFilter {
  value: string;
  options: { code: string; name: string }[];
  onChange: (value: string) => void;
  searchText: string;
  setSearchText: (value: string) => void;
  filterValue?:string;
  setFilterValue?: (value: string) => void;
  currencies: CurrencyDataType[];
}

const CurrencyDrop: FC<ICurrencyFilter> = ({
  value,
  options,
  onChange,
  searchText,
  setSearchText,
  filterValue,
  setFilterValue,
  currencies,
}) => {
  const [open, setOpen] = useState(false);
  const node = useRef<HTMLDivElement | null>(null);
  // Temporary

  const currenciesList = currencies.map((item) => ({
    code: item.code,
    name: item.code.toUpperCase(),
  }));

  const handleClick = (event: MouseEvent): boolean | undefined => {
    if (node?.current?.contains(event.target as Node)) {
      return false;
    }

    setOpen(false);
    return true;
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  const handleChange = (selectedValue: string): void => {
    onChange(selectedValue);
    setSearchText("");
    setOpen(false);
  };

  const handleSelectToggel = (): void => {
    setOpen((prev) => !prev);
  };

  const onSearchTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    const currentText = e.target.value;
    setSearchText(currentText);
  };

  const selected = options.find((item) => item.code === value);

  return (
    <div className="w-full sm:w-[320px] flex flex-row rounded-[10px] border-[1px] border-light-300">
     
      <div className="flex-1 relative bg-white rounded-[10px] ">
          <>
            <input
              className="h-[44px] focus:ring-0 placeholder-other w-full appearance-none text-[16px] font-manrope font-medium rounded-[10px] border-none bg-transparent pl-4 pr-8  text-primary ring-0"
              type="text"
            //   placeholder="Search By TransactionId and UserId"
              value={searchText}
              onChange={onSearchTextChange}
            />
            <SearchIcon className="absolute right-[8px] top-[14px] w-[16px] h-[16px] text-secondary" />
          </>
      </div>
    </div>
  );
};

CurrencyDrop.displayName = "CurrencyDrop";
export default CurrencyDrop;
